import { PersonGroupModel } from "../../models/person-group.model";

export const getLatestUpdatedPersonGroup = (list: PersonGroupModel[]): PersonGroupModel => {
    const [latest] = list.sort((modelA, modelB) =>
        (new Date(modelA.updatedAt) < new Date(modelB.updatedAt)) ? 1 : -1
    );
    return latest;
}
